import { cx } from "class-variance-authority"
import { GlobalContainer } from "src/GlobalStyled"
import { DefaultLayoutProps } from "src/types/layoutTypes"
import MainHeader from "src/views/components/common/Header/MainHeader"
import DefaulFooter from "./DefaultFooter/DefaultFooter"

const MainLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <>
      <MainHeader />
      <main className="bg-neutral-5">
        <GlobalContainer className={cx(`min-h-screen pb-16 md:pt-10`)}>{children}</GlobalContainer>
      </main>
      <footer>
        <DefaulFooter />
      </footer>
    </>
  )
}
export default MainLayout
